<template>
  <div>
    <div
      class="book"
      :style="{ 'background-color': bgc }"
      :class="{ startBtn: bgc !== '#242B2A' }"
    >
      {{ buttonLabel }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgc: {
      type: String,
      default: '#242B2A'
    },
    buttonLabel: {
      type: String,
      default: 'Start for free'
    }
  }
}
</script>

<style scoped lang="less">
.startBtn {
  padding: 0.266667rem /* 10/37.5 */ !important;
  color: #ffffff;
  font-size: 0.32rem !important;
  display: inline-block;
  max-width: 3.2rem /* 120/37.5 */;
  text-align: center;
}
.book {
  margin: 0.4rem 0;
  padding: 0.28rem 0.72rem;
  border-radius: 0.64rem;
  color: #ffffff;
  font-size: 0.4rem;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
}
</style>
